import { default as PreviewCardSLAIcon } from '../../_internal/components/PreviewCardSLAIcon';
export default PreviewCardSLAIcon;